<template>
  <base-table
    :loading="loading"
    :data="preparedAccounts"
    class="customer-account-table">
    <el-table-column
      prop="appLoginName"
      width="200"
      :label="$t('base.appLoginName')"
    >
    </el-table-column>
    <el-table-column prop="firstName" :label="$t('base.firstName')">
    </el-table-column>

    <el-table-column prop="lastName" :label="$t('base.lastName')">
    </el-table-column>

    <el-table-column prop="email" min-width="300" :label="$t('base.email')">
    </el-table-column>

    <el-table-column align="center" :label="$t('settings.active')">
      <template slot-scope="account">
        <div @click.stop>
          <el-switch
            v-model="account.row.active"
            @change="$emit('toggleActive', account.row)"
          >
          </el-switch>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      align="center"
      :label="$t('settings.report_sort.sort_title')"
    >
      <template slot-scope="account">
        <el-select
          v-model="account.row.reportSort"
          @change="$emit('accountUpdate', account.row)"
        >
          <el-option
            value="TYPE_DATE"
            :label="$t('settings.report_sort.TYPE_DATE')"
            key="TYPE_DATE"
          ></el-option>
          <el-option
            value="CREATED_DATE"
            :label="$t('settings.report_sort.CREATED_DATE')"
            key="CREATED_DATE"
          ></el-option>
          <el-option
            value="UPDATE_DATE"
            :label="$t('settings.report_sort.UPDATE_DATE')"
            key="UPDATE_DATE"
          ></el-option>
          <el-option
            value="START_DATE"
            :label="$t('settings.report_sort.START_DATE')"
            key="START_DATE"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column align="center" :label="$t('settings.mail_reception')">
      <template slot-scope="account">
        <div v-if="account.row.email">
          <el-switch
            v-model="account.row.receivesMail"
            @change="$emit('accountUpdate', account.row)"
          >
          </el-switch>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      min-width="70"
      align="center"
      :label="$t('settings.authority')"
    >
      <template slot-scope="account">
        <el-tag v-if="account.row.userAuthority === 'ADMIN'">Admin</el-tag>
        <el-tag v-if="account.row.userAuthority === 'REPORTER'" type="info">Reporter</el-tag>
        <el-tag v-if="account.row.userAuthority === 'USER'" type="info">User</el-tag>
      </template>
    </el-table-column>

    <el-table-column prop="otherCustomer" :label="$t('settings.otherCustomer')">
    </el-table-column>

    <el-table-column
      align="center"
      width="200"
      :label="$t('settings.notificationSettings.notificationTitle')">
      <template slot-scope="account">
        <el-select
          v-model="account.row.notificationSettings"
          @change="$emit('accountUpdate', account.row)">
          <el-option
            value="NONE"
            :label="$t('settings.notificationSettings.NONE')"
            key="NONE"
          ></el-option>
          <el-option
            value="ONLY_DISORDER"
            :label="$t('settings.notificationSettings.ONLY_DISORDER')"
            key="ONLY_DISORDER"
          ></el-option>
          <el-option
            value="ALL"
            :label="$t('settings.notificationSettings.ALL')"
            key="ALL"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column
      fixed="right"
      align="center"
      min-width="180"
      :label="$t('settings.operations')">
      <template slot-scope="account">
        <el-tooltip :content="$t('settings.account.sendEmail')" placement="top">
          <el-button
            :disabled="!account.row.email"
            size="small"
            type="primary"
            circle
            icon="el-icon-message"
            @click="$emit('sendEmail', account.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip :content="$t('settings.account.sendPush')" placement="top">
          <el-button
            :disabled="!account.row.hasPushToken"
            circle
            type="primary"
            size="small"
            icon="el-icon-mobile-phone"
            @click="$emit('sendPush', account.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('settings.account.resetPushToken')"
          placement="top">
          <el-button
            :disabled="!account.row.hasPushToken"
            circle
            type="warning"
            size="small"
            icon="el-icon-remove"
            @click="$emit('resetPushToken', account.row)"></el-button>
        </el-tooltip>
        <el-tooltip
          v-if="showLocalAccounts"
          :content="$t('settings.edit')"
          placement="top"
        >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click.stop.prevent="$emit('editAccount', account.row)"
            circle
          ></el-button>
        </el-tooltip>
        <el-tooltip
          v-if="showLocalAccounts"
          :content="$t('settings.account.delete')"
          placement="top"
        >
          <el-button
            circle
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="$emit('delete', account.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </base-table>
</template>

<script>
import BaseTable from '@/components/common/BaseTable';

export default {
  name: "CustomerAccountsTable",
  components: {BaseTable},
  props: {
    accounts: {
      type: Array,
      default: () => [],
    },
    showLocalAccounts: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    tenantId: {
      type: String,
      default: null,
    },
    customerId: {
      type: String,
      default: null,
    },
  },
  computed: {
    preparedAccounts() {
      this.accounts.forEach(account => {
        // Filter all other customer than the current customer (id of current customer is in url)
        account.otherCustomer = account.customers
          .filter(customer => customer.id !== this.$route.params.id)
          .map(customer => customer.name)
          .join();
      });
      return this.accounts;
    }
  }
};
</script>
